import router from './router'
import store from './store'

router.beforeEach(async(to, from, next) => {
  if(!store.getters.loaded) {
    const accessRoutes = await store.dispatch('permission/generateRoutes')
    // dynamically add accessible routes
    router.addRoutes(accessRoutes)
    next({ ...to, replace: true })
  }else {
    next()
  }
})



// WEBPACK FOOTER //
// ./src/permission.js